<template>
  <Transition
    enter-active-class="ease-in duration-200"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="ease-out duration-200"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <ProductPopup
      v-if="product && menu"
      :product="product"
      :menu="menu"
      @hide="previewingProductStore.setPreviewingProduct(null)"
    />
  </Transition>
</template>

<script setup lang="ts">
import ProductPopup from '@menu/Shared/ProductPopup.vue';
import { usePreviewingProductStore } from '@menu/Stores/previewingProduct';
import { computed } from 'vue';
import getRestaurant from '@menu/Utils/getRestaurant';

const previewingProductStore = usePreviewingProductStore();

const restaurant = getRestaurant();

const product = computed(() => previewingProductStore.previewingProduct);

const menu = computed(() => {
  const productId = product.value?.id;

  if (!productId) {
    return null;
  }

  for (const menu of restaurant.menus) {
    for (const category of menu.categories) {
      if (category.products.some(({ id }) => id === productId)) {
        return menu;
      }
    }
  }

  throw new Error('Unable to detect menu.');
});
</script>
